import { TFunction } from 'i18next'
import { AdGroupBudgetHistoryUser } from './budgetHistoryTypes'

/** A null user means the change was made by a platform process. */
export type BudgetHistoryChangeAuthor = {
  user: AdGroupBudgetHistoryUser | null
}

export const formatBudgetHistoryChangeAuthor = (
  t: TFunction,
  author: BudgetHistoryChangeAuthor | null | undefined
): string | null => {
  if (author == null) return null
  if (author.user == null) return t('activity.feed.platform')

  const name = `${author.user.firstName} ${author.user.lastName}`.trim()
  return name.length > 0 ? name : t('activity.feed.userNotFound')
}
